import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { EnvironmentService } from '@core/services/environment.service';

export interface AssetImageConfiguration {
    /** 1x URL; also the default source. Densities are prebuilt — the renderer
     *  appends no query parameters. */
    src: string;
    src2x?: string;
    src3x?: string;
    alt?: string;
    ratioWidth?: number;
    ratioHeight?: number;
    placeholderColor?: string;
}

@Component({
    selector: 'app-lazy-asset-lazy',
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './lazy-asset-lazy.component.html',
})
export class LazyAssetLazyComponent {
    private environmentService = inject(EnvironmentService);

    defaultSrc = input<string>('');
    altText = input.required<string>();
    sourceSet = input<string>('');
    additionalClasses = input<string | string[]>([]);
    svgPlaceholder = input.required<SafeUrl>();
}
